var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTradeGoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36346 0.183594C1.15848 0.183594 0.181641 1.16041 0.181641 2.36541V4.18075H19.818V2.36541C19.818 1.16041 18.8412 0.183594 17.6362 0.183594H2.36346Z",
    fill: "#5D688B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.818 6.90803H15.4544V9.6353C15.4544 10.8403 14.4775 11.8171 13.2726 11.8171H6.7271C5.52211 11.8171 4.54528 10.8403 4.54528 9.6353V6.90803H0.181641V17.6381C0.181641 18.8431 1.15848 19.82 2.36346 19.82H17.6362C18.8412 19.82 19.818 18.8431 19.818 17.6381V6.90803Z",
    fill: "#5D688B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27255 6.90803H12.7271V9.08984H7.27255V6.90803Z",
    fill: "#5D688B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTradeGoods);
export default __webpack_public_path__ + "static/media/nav-trade-goods.3e3eac84.svg";
export { ForwardRef as ReactComponent };